module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.hasError) ? _c('v-alert', {
    attrs: {
      "type": "error",
      "value": !!_vm.error
    }
  }, [_vm._v(_vm._s(this.error))]) : _vm._e(), _vm._v(" "), _c('v-flex', [_vm._l((_vm.customerItem), function(val, key) {
    return _c('v-text-field', {
      key: key,
      attrs: {
        "label": key,
        "value": val,
        "readonly": ['id', 'customerId', 'customerIdUnique'].includes(key)
      },
      model: {
        value: (_vm.customerItem[key]),
        callback: function($$v) {
          _vm.$set(_vm.customerItem, key, $$v)
        },
        expression: "customerItem[key]"
      }
    })
  }), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialogSave = true
      }
    }
  }, [_vm._v("Save changes")]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "290"
    },
    model: {
      value: (_vm.dialogSave),
      callback: function($$v) {
        _vm.dialogSave = $$v
      },
      expression: "dialogSave"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n          Are you sure you want to save your changes?\n        ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.dialogSave = false
      }
    }
  }, [_vm._v("\n            Cancel\n          ")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.dialogSave = false;
        _vm.updateCustomer()
      }
    }
  }, [_vm._v("\n            Save\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialogDelete = true
      }
    }
  }, [_vm._v("Delete")]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "290"
    },
    model: {
      value: (_vm.dialogDelete),
      callback: function($$v) {
        _vm.dialogDelete = $$v
      },
      expression: "dialogDelete"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n          Are you sure you want to delete this contact?\n        ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.dialogDelete = false
      }
    }
  }, [_vm._v("\n            Cancel\n          ")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.deleteCustomer()
      }
    }
  }, [_vm._v("\n            Delete\n          ")])], 1)], 1)], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-loader/lib/template-compiler?{"id":"data-v-1331d123"}!/export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-loader/lib/selector.js?type=template&index=0!./client/views/GetCustomer.vue
// module id = 920
// module chunks = 1